<div class="row row5">
    <div class="col-md-9 featured-box-detail sports-wrapper m-b-10" >
      <div *ngIf="data">
        <div class="game-heading"><span class="card-header-title">{{(data?.event?.event?.event_type_id == '7')?'HR - ':(data?.event?.event?.event_type_id == '4339')?'GR -':''}}{{data?.event?.event?.name}}</span> 
          <span class="float-right">
            <span *ngIf="events.races.includes(data?.event?.event?.event_type_id)">{{data?.event?.event?.market_start_time | date : 'dd/MM/YYYY HH:mm:ss'}}</span>
            <span *ngIf="!events.races.includes(data?.event?.event?.event_type_id)">{{data?.event?.event?.open_date | date : 'dd/MM/YYYY HH:mm:ss'}}</span>
          </span>
          <!-- <span class="float-right" *ngIf="events.races.includes(data?.event?.event?.event_type_id)">{{data?.event?.event?.market_start_time | date : 'dd/MM/YYYY HH:mm:ss'}}</span>
          <span class="float-right" *ngIf="!events.races.includes(data?.event?.event?.event_type_id)">{{data?.event?.event?.open_date | date : 'dd/MM/YYYY HH:mm:ss'}}</span> -->
          </div>

        <!-- SHOW TV IF VIRTUAL GAMES -->
        <div align="center" class="tv-container" *ngIf="!isLoginWithDemo() && isLogin() && data?.event?.event?.category == events_category?.virtual">
          <iframe class="LiveStream-video-col" id="tvStr" [src]='iframeURL | safeURL'>
          </iframe>
        </div>
        <!-- /SHOW TV IF VIRTUAL GAMES -->

        <!-- score table -->
        <div style="margin-bottom: 3px;" class="" *ngIf="scoreHtml != ''" [innerHTML]="scoreHtml | safeHtml"></div>
        <!-- /score table -->

        <div class="markets">

          <!-- MATCH_ODDS -->
          <div class="main-market" *ngIf="data?.event?.match_odds?.status == 1">
            <!-- <div class="market-title mt-1"> -->
              <!-- MATCH_ODDS
              <button class="btn-cashout" *ngIf="data?.event?.match_odds?.runners.length == 2" (click)="cashOut(data?.event?.match_odds, 'match_odds')">cashout</button>
              <a href="javascript:void(0)" class="m-r-5 game-rules-icon" (click)="openModalWithComponent('m')"><span><i class="fa fa-info-circle float-right"></i></span></a>  -->
              <!-- <span class="float-right m-r-10">Maximum Bet <span>1</span></span> -->
            <!-- </div> -->
            <app-market-detail [data]="{marketData: data?.event?.match_odds, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, mmIds: multiMarketIds}" (betDt)="openBetPlace($event)" (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-market-detail>

          </div>
          <!-- /MATCH_ODDS -->

          <!-- BOOKMAKER -->
          <div class="row row5 bookmaker-market mt-1" *ngIf="data?.event?.book_makers.length > 0">
            <div class="bm1 col-xl-12" *ngFor="let bmItem of data?.event?.book_makers;let bi=index;trackBy:trackByIndex;">
              <div *ngIf="bmItem.status == 1">
                  <!-- <div class="market-title mt-1">
                      {{bmItem?.title}}
                      <button class="btn-cashout" *ngIf="bmItem?.book_maker_odds.length == 2" (click)="cashOut(bmItem,'book_makers')">cashout</button>
                      <a href="javascript:void(0)" (click)="openModalWithComponent('b')" class="m-r-5 game-rules-icon"><span><i
                                  class="fa fa-info-circle float-right"></i></span></a>
                  </div> -->

                  <app-bookmaker-detail [data]="{marketData: bmItem, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, mmIds: multiMarketIds}" (betDt)="openBetPlace($event)" (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-bookmaker-detail>

              </div>
            </div>
          </div>
          <!-- /BOOKMAKER -->

        </div>

        <!--  LINE -->
        <div class="fancy-market row row5" >
          <div class="col-12" *ngIf="data?.event?.fancy.length > 0 && fLineMrk">
            <div>
              <div class="market-title mt-1">
                LINE
                <a href="javascript:void(0)" (click)="openModalWithComponent('f')"  class="m-r-5 game-rules-icon"><span><i class="fa fa-info-circle float-right"></i></span></a>
              </div>

              <app-fancy-detail [data]="{fancyData: data?.event?.fancy, tabVal:allFancy, isFancy:false, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, mmIds: multiMarketIds}" (betDt)="openBetPlace($event)" (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-fancy-detail>

            </div>
          </div>
        </div>
        <!-- /LINE -->

        <!-- FANCY -->
        <div class="fancy-tab" *ngIf="data?.event?.fancy.length > 0 && fFancyMrk">
          <tabset >

              <tab *ngFor="let tab of fancyTab">

                <ng-template tabHeading>
                  <span style="text-transform: uppercase;">{{getKeyName(tab.name)}}</span>
                </ng-template>

                <div *ngIf="!isCommon(tab.value,allFancy)">

                  <div class="fancy-market row row5" *ngIf="tab.name == 'all'">
                    <div class="col-6">
                      <div [ngClass]="(allDt.name == 'all' || isCommon(allDt.value,allFancy)) ? 'dn' : ''" *ngFor="let allDt of fancyTab;let i=index;">
                        <div *ngIf="allDt.name != 'all' && (i % 2) != 0">
                          <div class="market-title mt-1"><span>{{getKeyName(allDt.name)}}</span> <a href="javascript:void(0)" (click)="openModalWithComponent('f')"  class="m-r-5 game-rules-icon"><span><i class="fa fa-info-circle float-right"></i></span></a></div>
                          <app-fancy-detail [data]="{fancyData: data?.event?.fancy, tabVal:allDt.value, isFancy:true, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, mmIds: multiMarketIds}" (betDt)="openBetPlace($event)" (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-fancy-detail>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div [ngClass]="(allDt.name == 'all' || isCommon(allDt.value,allFancy)) ? 'dn' : ''" *ngFor="let allDt of fancyTab;let i=index;">
                        <div *ngIf="allDt.name != 'all' && (i % 2) == 0">
                          <div class="market-title mt-1"><span>{{getKeyName(allDt.name)}}</span> <a href="javascript:void(0)" (click)="openModalWithComponent('f')"  class="m-r-5 game-rules-icon"><span><i class="fa fa-info-circle float-right"></i></span></a></div>
                          <app-fancy-detail [data]="{fancyData: data?.event?.fancy, tabVal:allDt.value, isFancy:true, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, mmIds: multiMarketIds}" (betDt)="openBetPlace($event)" (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-fancy-detail>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="fancy-market row row5" *ngIf="tab.name != 'all'">
                    <div class="col-6">
                      <div class="market-title mt-1"><span>{{getKeyName(tab.name)}}</span> <a href="javascript:void(0)" (click)="openModalWithComponent('f')" class="m-r-5 game-rules-icon"><span><i class="fa fa-info-circle float-right"></i></span></a></div>
                      <app-fancy-detail [data]="{fancyData: data?.event?.fancy, tabVal:tab.value, isFancy:true, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, mmIds: multiMarketIds}" (betDt)="openBetPlace($event)" (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-fancy-detail>
                    </div>
                  </div>

                </div>

                <div *ngIf="isCommon(tab.value,allFancy)" class="fancy-market"><div class="fancy-message col-12 mt-1">No real-time records found</div></div>
              </tab>
          </tabset>
        </div>
        <!-- /FANCY -->

        <!-- OTHER MARKETS -->
        <div class="markets" *ngFor="let item of data?.event?.markets; let i=index; trackBy:trackByIndex;">
          <div class="main-market" *ngIf="(item.market_type_id != 'MATCH_ODDS' && item.status != 4) && (mId == null || mId == item.market_id) " [ngClass]="data?.event?.event?.event_type_id == 7 ? 'horse-market' : ''">

            <app-market-detail *ngIf="!events.races.includes(data?.event?.event?.event_type_id)" [data]="{marketData: item, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList, mmIds: multiMarketIds}" (betDt)="openBetPlace($event)" (multiMUpdate)="multiMarketUpdate($event?.item, $event?.key)"></app-market-detail>

            <!-- race detail -->
            <div class="market-title mt-1" *ngIf="events.races.includes(data?.event?.event?.event_type_id)">
              {{item.market_name}} 
              <!-- <button class="btn-cashout" *ngIf="item?.runners.length == 2" (click)="cashOut(item, 'match_odds')">cashout</button> -->
              <span > 
                <button class="btn-cashout" *ngIf="!item?.bet_open && raceTimer && raceTimer != ''">{{raceTimer}}</button>
                <button class="btn-cashout" *ngIf="item?.bet_open && (oddsLisDisNew[item?.market_id]?.inplay == '' || oddsLisDisNew[item?.market_id]?.inplay == 0)">Betting Open</button>
                <button class="btn-cashout" *ngIf="oddsLisDisNew[item?.market_id]?.inplay == 1">In Play</button>
              </span> 
              <!-- <a href="javascript:void(0)" class="m-r-5 game-rules-icon" data-toggle="modal" data-target="#rules"><span><i class="fa fa-info-circle float-right"></i></span></a> <span class="float-right m-r-10">Maximum Bet <span>1</span></span> -->
            </div>
            <app-race-detail *ngIf="events.races.includes(data?.event?.event?.event_type_id)" [data]="{marketData: item, event_type_id:data?.event?.event?.event_type_id, odds: oddsLisDis, expo: exposLisDis, nextExpo: nextExpoList}" (betDt)="openBetPlace($event)"></app-race-detail>
            <!-- race detail -->

          </div>
        </div>


        <!-- /OTHER MARKETS -->

      </div>

      <app-loader *ngIf="isLoad" [isFpLoader]="false"></app-loader>

    </div>
    <div id="sidebar-right" class="col-md-3 sidebar-right" [ngClass]="{ 'bestlip-fixed': scrolled }">
      <div class="ps">
        <div class="sidebar-right-inner">
          <div class="card m-b-10" style="border: 0px;" *ngIf="isLogin()">
            <div class="card-header">
              <h6 class="card-title">
                Live Match
                <span class="float-right" (click)="getTvData()" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic">
                  <i class="fa fa-tv"></i> live stream started
                </span>
              </h6>
            </div>
            <div align="center" class="tv-container" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true" >
              <div id="tv-block-id-desk">
                <iframe *ngIf="data && data.event?.event?.tv_provider != 'flash'" [src]='iframeURL | safeURL' class="LiveStream-video-col"></iframe>
              </div>
            </div>
          </div>
          <div class="card m-b-10 place-bet">
            <div class="card-header">
              <h6 class="card-title d-inline-block">Place Bet</h6>
            </div>
            <div>
              <app-d-bet-slip [data]="betSlipData" [exposLisDis]="exposLisDis" (closeBet)="closeBet($event)" (updateData)="updateData($event)" (changeExpo)="changeExpo($event)"></app-d-bet-slip>
            </div>
          </div>
          <div class="card m-b-10 my-bet">
            <div class="card-header">
              <h6 class="card-title d-inline-block">My Bet</h6>
            </div>
            <div class="card-body">
              <app-d-bet-list *ngIf="isLogin()"></app-d-bet-list>
            </div>
          </div>
        </div>
        <div class="ps__rail-x" style="left: 0px; bottom: 0px;">
          <div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px;"></div>
        </div>
        <div class="ps__rail-y" style="top: 0px; right: 0px;">
          <div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 0px;"></div>
        </div>
      </div>
    </div>
  </div>
